module.exports = __webpack_public_path__ + "img/Frame Logo Desktop.6d0a1b1f.webp";